import { mapState, mapGetters } from 'vuex';
import { isAfter, parseISO } from 'date-fns';
import slideAnimation from 'mixins/slideAnimation';
import DocumentResultAsset from 'components/product-sheets/DocumentResultAsset.vue';
import DocumentResultMsdsAsset from 'components/product-sheets/DocumentResultMsdsAsset.vue';
import MobileDocumentResultAsset from 'components/product-sheets/mobile/DocumentResultAsset.vue';
import MobileDocumentResultMsdsAsset from 'components/product-sheets/mobile/DocumentResultMsdsAsset.vue';
import ResultStateIndicators from 'components/ResultStateIndicators.vue';

export default {
  props: {
    assets: {
      type: Array,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      groupOpen: false
    };
  },
  mixins: [slideAnimation],
  components: { DocumentResultAsset, DocumentResultMsdsAsset, ResultStateIndicators },
  computed: {
    ...mapState(['fieldManifest', 'basket']),
    ...mapGetters(['isMobile', 'isMySheets', 'basketIds']),
    ...mapState('user', ['activeUser']),
    assetResultComponent() {
      if (!this.hasMultipleAssets && this.firstAsset.type === 'virtual_msds') {
        return this.isMobile ? MobileDocumentResultMsdsAsset : DocumentResultMsdsAsset;
      }

      return this.isMobile ? MobileDocumentResultAsset : DocumentResultAsset;
    },
    hasMultipleAssets() {
      return this.assets.length > 1;
    },
    firstAsset() {
      return this.assets[0];
    },
    typeLabel() {
      return this.fieldManifest.hasOwnProperty(this.firstAsset.type)
        ? this.fieldManifest[this.firstAsset.type].title
        : this.firstAsset.type;
    },
    idsInBasket() {
      return this.assets.filter((asset) => this.basketIds.has(asset.id));
    },
    isInBasket() {
      return this.idsInBasket.length === this.assets.length;
    },
    partiallyInBasket() {
      return this.idsInBasket.length > 0;
    },
    hasNewDocuments() {
      if (!this.activeUser || !this.activeUser.previousLogin) {
        return false;
      }

      const newVersions = this.assets.filter(
        (asset) => isAfter(parseISO(asset.createdDate), parseISO(this.activeUser.previousLogin)) && asset.isRootVersion
      );

      return newVersions.length > 0;
    },
    hasNewDocumentVersions() {
      if (!this.activeUser || !this.activeUser.previousLogin) {
        return false;
      }

      const newVersions = this.assets.filter(
        (asset) => isAfter(parseISO(asset.createdDate), parseISO(this.activeUser.previousLogin)) && !asset.isRootVersion
      );

      return newVersions.length > 0;
    }
  },
  methods: {
    openGroup() {
      this.groupOpen = true;
    },
    closeGroup() {
      this.groupOpen = false;
    },
    toggleGroup() {
      if (this.groupOpen) this.closeGroup();
      else this.openGroup();
    },
    toggleBasket() {
      if (!this.isInBasket) this.$store.dispatch('addToBasket', this.assets);
      else this.$store.dispatch('removeFromBasket', this.assets);
    }
  }
};
